/** Hauteur minimale des cartes bâtiment (liste d’accueil). */
export const HOME_BUILDING_CARD_MIN_HEIGHT = "8.5rem"
